import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-section-firmas',
  templateUrl: './section-firmas.component.html',
  styleUrls: ['./section-firmas.component.css']
})
export class SectionFirmasComponent implements OnChanges {

  @Input() public objetoSectionFirmas : SectionFirmas = {
    medicoAtencion : "",
    descripcionMedico : "",
    registroMedico : "",
    imagenAfiliado : "",
    imagenFirma : ""
  }

  constructor() { }

  ngOnChanges() {
    this.getObjetoSectionFirmas();
  }

  public async getObjetoSectionFirmas() {
    try {
      await this.objetoSectionFirmas;
    } catch(exception) {
      console.log(exception);
    }
  }

}

interface SectionFirmas {
  medicoAtencion : string,
  descripcionMedico : string,
  registroMedico : string,
  imagenAfiliado : string,
  imagenFirma : string
}